import React, { useEffect, useRef, useState } from "react";

const banners = [
  "https://dl2n11pngizv0.cloudfront.net/garudaags/Picsart_26-07-11_06-52-12-934.png",
  "https://dl2n11pngizv0.cloudfront.net/garudaags/Picsart_26-07-14_10-10-09-619.jpg.jpeg",
  "https://dl2n11pngizv0.cloudfront.net/garudaags/Picsart_26-07-11_07-18-33-369.png",
];

const AUTO_PLAY_TIME = 3000;
const SWIPE_THRESHOLD = 50;



export default function CenterCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);
  // const [aspectRatio, setAspectRatio] = useState(16 / 9);

  const startX = useRef(0);
  const isDragging = useRef(false);
  const isTransitioning = useRef(false);

const goNext = () => {
  if (isTransitioning.current) return;
  isTransitioning.current = true;
  setActiveIndex((prev) => (prev + 1) % banners.length);
  setTimeout(() => { isTransitioning.current = false; }, 600);
};

const goPrev = () => {
  if (isTransitioning.current) return;
  isTransitioning.current = true;
  setActiveIndex((prev) => (prev - 1 + banners.length) % banners.length);
  setTimeout(() => { isTransitioning.current = false; }, 600);
};

// And change autoplay deps to [] so timer doesn't restart on every slide
useEffect(() => {
  const timer = setInterval(() => {
    if (!isDragging.current) goNext();
  }, AUTO_PLAY_TIME);
  return () => clearInterval(timer);
}, []); // ← empty deps
   
  /* Load current image size */
  // useEffect(() => {
  //   const img = new Image();

  //   img.onload = () => {
  //     setAspectRatio(img.naturalWidth / img.naturalHeight);
  //   };

  //   img.src = banners[activeIndex];
  // }, [activeIndex]);

  



 
  const handleStart = (x) => {
    startX.current = x;
    isDragging.current = true;
  };

  const handleEnd = (x) => {
    if (!isDragging.current) return;

    const diff = startX.current - x;

    isDragging.current = false;

    if (Math.abs(diff) < SWIPE_THRESHOLD) return;

    diff > 0 ? goNext() : goPrev();
  };

const getStyle = (index) => {
  const total = banners.length;
  let offset = index - activeIndex;

  if (offset > total / 2) offset -= total;
  if (offset < -total / 2) offset += total;

  const isVisible = Math.abs(offset) <= 1;   // ← key guard

  let translateX = offset * 96;
  let scale = offset === 0 ? 1 : 0.85;
  let zIndex = offset === 0 ? 3 : 2;

  return {
    transform: `translateX(${translateX}%) scale(${scale})`,
    opacity: isVisible ? 1 : 0,
    zIndex,
    pointerEvents: isVisible ? "auto" : "none",  // ← prevent ghost clicks
    visibility: isVisible ? "visible" : "hidden", // ← belt-and-suspenders
  };
};

  return (
    <div style={styles.wrapper}>
      <div
        style={{
          ...styles.carousel,
          aspectRatio: "16/9",
        }}
        onTouchStart={(e) =>
          handleStart(e.touches[0].clientX)
        }
        onTouchEnd={(e) =>
          handleEnd(e.changedTouches[0].clientX)
        }
        onMouseDown={(e) => handleStart(e.clientX)}
        onMouseUp={(e) => handleEnd(e.clientX)}
        onMouseLeave={() => {
          isDragging.current = false;
        }}
      >
        {banners.map((img, index) => (
          <div
            key={index}
            style={{
              ...styles.item,
              ...getStyle(index),
            }}
          >
            <img
              src={img}
              alt={`banner-${index}`}
              draggable={false}
              style={styles.image}
            />
          </div>
        ))}
      </div>

      <div style={styles.dots}>
        {banners.map((_, index) => (
          <span
            key={index}
            onClick={() => setActiveIndex(index)}
            style={{
              ...styles.dot,
              background:
                activeIndex === index
                  ? "#ffffff"
                  : "rgba(255,255,255,.4)",
            }}
          />
        ))}
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    width: "100%",
    maxWidth: "900px",
    margin: "0 auto",
    overflow: "hidden",
  },

  carousel: {
    position: "relative",
    width: "100%",
    maxWidth: "100%",
    minHeight: "140px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },

item: {
  position: "absolute",
  width: "85%",
  overflow: "hidden",
  borderRadius: "33px",
  background: "#fff",
  transition: "transform 0.6s ease-in-out, opacity 0.6s ease-in-out", // ← not "all"
  willChange: "transform, opacity"
},

image: {
  width: "100%",
  height: "100%",
  marginLeft: "0%",
  marginTop: "0%",
  objectFit: "cover",
  display: "block",
},

  dots: {
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    marginBottom: "15px",
  },

  dot: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    cursor: "pointer",
    transition: "all .3s ease",
  },
};